import { useContext, useEffect, useMemo } from 'react';
import AssociationHeaderQuery from '../AssociationHeaderQuery';
import { StandardVy } from '../StandardVy';
import {
  IClientAssociationModel,
  IClientBusinessModel,
} from '../../../../../../Types/ClientModelTypes';
import { MdModalRoute } from '../../../../../../Components/MasterDetail/Components/MdModal/MdModalRoute';
import {
  IMasterCompProps,
  IDetailCompProps,
} from '../../../../../../Types/MasterDetailTypes';
import { createPortal } from 'react-dom';
import BusinessDataObjectDetailHeader from '../BusinessDataObjectDetailHeader/BusinessDataObjectDetailHeader';

import { BreadcrumbsContext } from '../../RutinBreadcrumbs/BreadcrumbsContext';
import { nth } from 'ramda';
import EDIconButton from '../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';

interface IProps {
  businessModel: IClientBusinessModel;
  associatedId: string | null;
  assoc: IClientAssociationModel;
  associatedCollection: IClientBusinessModel;
}

export const AssociatedObjectLink = (props: IProps) => {
  const master = useMemo(() => {
    return {
      caption: props.businessModel.RootType.SBLabel,
      comp: (masterprops: IMasterCompProps) => {
        const {
          headerReferences,
          currentNavLevel,
          topNavLevel,
          backButtonReferences,
          registerActiveNavLevel,
          unregisterActiveNavLevel,
          // eslint-disable-next-line react-hooks/rules-of-hooks
        } = useContext(BreadcrumbsContext);
        const headerRef =
          masterprops.selectedDetail && currentNavLevel !== undefined
            ? headerReferences[currentNavLevel]
            : undefined;
        const renderHeader = headerRef != null;
        const backRef =
          masterprops.selectedDetail &&
          currentNavLevel !== undefined &&
          currentNavLevel === topNavLevel
            ? nth(currentNavLevel, backButtonReferences) || null
            : null;
        const unselectDetail = () => masterprops.selectDetail(null);
        const selectCurrentDetail = () =>
          masterprops.selectDetail(masterprops.selectedDetail);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (renderHeader && currentNavLevel) {
            registerActiveNavLevel(currentNavLevel);
            return () => unregisterActiveNavLevel(currentNavLevel);
          }
          return undefined;
        }, [
          renderHeader,
          currentNavLevel,
          registerActiveNavLevel,
          unregisterActiveNavLevel,
        ]);
        return (
          <>
            <AssociationHeaderQuery
              collectionName={props.assoc.AssociatedCollectionName}
              id={props.associatedId}
              displayLabel={props.assoc.DisplayLabel}
              infoClick={() => masterprops.selectDetail(props.associatedId)}
            />
            <BusinessDataObjectDetailHeader
              collectionName={props.assoc.AssociatedCollectionName}
              id={props.associatedId}
              headerRef={headerRef}
              caption={props.assoc.DisplayLabel}
              onClick={
                currentNavLevel !== topNavLevel
                  ? selectCurrentDetail
                  : undefined
              }
            />
            ,
            {backRef &&
              createPortal(
                <EDIconButton
                  icon="arrow_back"
                  color="inherit"
                  tooltip={`Tillbaka till ${props.businessModel.RootType.SBLabel}`}
                  padding="dense"
                  marginTop={0.5}
                  marginBottom={0.5}
                  onClick={unselectDetail}
                />,
                backRef
              )}
          </>
        );
      },
    };
  }, [props.businessModel, props.assoc, props.associatedId]);
  const detail = useMemo(() => {
    return {
      caption: props.assoc.DisplayLabel,
      comp: (_detailprops: IDetailCompProps) => (
        <StandardVy bmod={props.associatedCollection} id={props.associatedId} />
      ),
    };
  }, [props.assoc, props.associatedCollection, props.associatedId]);
  return (
    <MdModalRoute
      detailRouteName={props.assoc.AssociationName}
      master={master}
      detail={detail}
      collection={props.associatedCollection}
    />
  );
};
